import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_team_management-multi_user_homepage_team_modal_cta-click';

/**
 * A click event for the CTA in the homepage team modal for multi users. This modal shows a list of the members in the user's team. This modal will show up when the user clicks the multi user avatars from the homepage evergreen banner
 */
export function trackRetailerTeamManagementMultiUserHomepageTeamModalCtaClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
